module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./MessageDetailView.js"));
	}, "MessageDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MessageDetailView!./src/pages/MessageManage/MessageDetail/MessageDetailView.js
// module id = ./node_modules/bundle-loader/index.js?lazy&name=MessageDetailView!./src/pages/MessageManage/MessageDetail/MessageDetailView.js
// module chunks = 43